/* __next_internal_client_entry_do_not_use__ PasswordInput auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import * as React from "react";
import { Eye } from "../../icons/foundation/Eye";
import { Input } from "../index";
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/component/input/web/password-input)
 */ export var PasswordInput = function(props) {
    var _React_useState = _sliced_to_array(React.useState(false), 2), showPassword = _React_useState[0], setShowPassword = _React_useState[1];
    return /*#__PURE__*/ _jsx(Input, _object_spread_props(_object_spread({}, props), {
        suffixNode: /*#__PURE__*/ _jsx(EyeButton, {
            onClick: function() {
                return setShowPassword(!showPassword);
            },
            closed: !showPassword
        }),
        type: showPassword ? "text" : "password",
        spellCheck: false,
        autoComplete: "off"
    }));
};
/**
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/IconButton/IconButton#IconButton"
 */ var EyeButton = function(param) {
    var closed = param.closed, onClick = param.onClick;
    return /*#__PURE__*/ _jsx("button", {
        onClick: onClick,
        "aria-label": "Show Password",
        "data-test-id": "showPasswordButton",
        children: /*#__PURE__*/ _jsx(Eye, {
            color: Core.icon.default,
            closed: closed
        })
    });
};
